import { ApiRoutes } from '@/api/ApiRoutes';
import axios from 'axios';
import { store } from '../store/store';
import TimezoneOffset from './TimezoneOffset';
import { GetCookieByName } from './Cookies/CookieHelper';

interface AppLoginTokenResponse {
  token: string;
  countryCode: string;
}

export default {

  Go(appRedirectUrl: string, appRedirectKey: string, useTarget: boolean, path?: string) {
    store.state.loadingCount++;
    const cacheBuster = Date.now();

    axios.get(ApiRoutes.Auth.GetAntiForgeryToken+"?t="+cacheBuster).then(() => {
      const requestToken = GetCookieByName(store.state.cookieContract.xsrfRequestToken);
      
      axios.post(ApiRoutes.Auth.GetAuthAppRedirectToken+"?t="+cacheBuster,
        {
          "__RequestVerificationToken": requestToken,
          "AppKey":appRedirectKey
        },
        {
          headers: {
            "X-XSRF-TOKEN": requestToken
          }
      }).then((response) => {
        const appLoginResponse = response.data as AppLoginTokenResponse;
        
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = appRedirectUrl;


        // Never open a new top-level window when embedded (e.g. Epic Hyperdrive iframe) — the embedded
        // browser blocks new windows and hangs; submit in the current frame instead.
        const embedded = window.self !== window.top;
        if (appRedirectKey && appRedirectKey.length > 0 && useTarget && !embedded)
            form.target = appRedirectKey + '_' + store.state.sessionId;

        form.setAttribute('style', 'display:none;');

        const tokenEl = document.createElement('input');
        tokenEl.value = appLoginResponse.token;
        tokenEl.name = 'token';
        form.appendChild(tokenEl);
        
        const utcOffsetEl = document.createElement('input');
        utcOffsetEl.value = TimezoneOffset().toString();
        utcOffsetEl.name = 'utcOffset';
        form.appendChild(utcOffsetEl);
        
        const userAgentEl = document.createElement('input');
        userAgentEl.value = navigator.userAgent;
        userAgentEl.name = 'userAgent';
        form.appendChild(userAgentEl);
        
        const countryCodeEl = document.createElement('input');
        countryCodeEl.value = appLoginResponse.countryCode;
        countryCodeEl.name = 'countryCode';
        form.appendChild(countryCodeEl);
        
        const regionalDomainEl = document.createElement('input');
        regionalDomainEl.value = window.location.origin;
        regionalDomainEl.name = 'regionalDomain';
        form.appendChild(regionalDomainEl);
        
        if (typeof path !== 'undefined') {
            const pathEl = document.createElement('input');
            pathEl.value = path;
            pathEl.name = 'path';
            form.appendChild(pathEl);
        }

        // Forward the SMART launch context to the launched app so it opens on the launched chart and scopes its
        // per-launch state to the same browsing context. All of it rides the POST body, server-asserted via the
        // Smart_SessionState cookie and /api/auth/status; a standard (non-SMART) session has none of it set, so
        // nothing is appended.
        if (store.state.launchType) {
            const launchTypeEl = document.createElement('input');
            launchTypeEl.value = store.state.launchType;
            launchTypeEl.name = 'launchType';
            form.appendChild(launchTypeEl);
        }
        if (store.state.browserTabId) {
            const browserTabIdEl = document.createElement('input');
            browserTabIdEl.value = store.state.browserTabId;
            browserTabIdEl.name = 'browserTabId';
            form.appendChild(browserTabIdEl);
        }
        // Launch-context entries are posted in dictionary form — LaunchContext[{key}] = value — so the receiving
        // app's MVC model binding materializes them as a Dictionary<string, string>. Keys arrive pre-translated as
        // external{TokenName} (driven by the server's SmartFhirConfig:*:ContextTokenClaims), so a token added in config
        // threads through with no client change.
        for (const [contextName, contextValue] of Object.entries(store.state.launchContext ?? {})) {
            if (!contextValue) continue;
            const contextEl = document.createElement('input');
            contextEl.value = contextValue;
            contextEl.name = `LaunchContext[${contextName}]`;
            form.appendChild(contextEl);
        }

        document.body.appendChild(form);
        window.setTimeout(function(){
          form.submit();
        },100);

      }).catch(function (error) {
        store.state.loadingCount = 0;
        console.log(error);

        if (error?.response?.status == 403)
          window.location.href = '/prelogin';
        else
          window.location.href = '/error?errorKey=unexpected';

      }).finally(() => {

      });
    }).catch(function (error) {
      store.state.loadingCount = 0;

      if (error?.response?.status == 403)
        window.location.href = '/prelogin';
      else
        window.location.href = '/error?errorKey=unexpected';

    }).finally(() => {
      store.state.loadingCount--;
    });
  }
};